import React from "react";

import { ZoneAvatar } from "@common/zoneAvatar";
import { Section } from "../../section";
import { filterSearch } from "../../utils";
import { Props } from "./types";
import { Projects } from "./projects";
import styles from "./styles.scss";

function Zone({ search, zone, selectedProject, onSelectProject }: Props) {
  return (
    <Section
      header={
        <div className={styles.header}>
          <div className={styles.icon}>
            <ZoneAvatar name={zone.name} color={zone.color} />
          </div>
          <p className={styles.name}>{zone.name}</p>
        </div>
      }
      list={
        <div className={styles.projects}>
          <Projects
            projects={filterSearch(zone.projects, search)}
            selectedProject={selectedProject}
            onSelectProject={onSelectProject}
          />
        </div>
      }
    />
  );
}

export { Zone };
